<template>
  <section class="wrapper">
    <van-form @submit="save">
      <van-field
        input-align="right"
        v-model="username"
        label="费用金额"
        placeholder="请输入金额"
        :rules="[{ required: true, message: '请输入金额' }]"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        name="picker"
        :value="value"
        label="供应商"
        placeholder="请选择"
        @click="showCollectionCompany = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        :value="value"
        label="付款方式"
        placeholder="请选择"
        @click="showPaymentSubType = true"
      />
      <van-field
        input-align="right"
        clickable
        :value="value"
        label="付款子类"
        placeholder="请选择"
      />
      <van-field
        input-align="right"
        clickable
        :value="value"
        label="业务单元"
        placeholder="请选择"
      />
      <van-field
        input-align="right"
        clickable
        :value="value"
        label="业务子单元"
        placeholder="请选择"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        :value="value"
        label="货币"
        placeholder="请选择"
        @click="showCurrency = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        :value="value"
        label="收款确认日期"
        placeholder="请选择"
        @click="showPaymentDate = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        :value="value"
        label="收款截止日期"
        placeholder="请选择"
        @click="showPaymentDate = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        :value="value"
        label="详细类别"
        placeholder="请选择"
        @click="showDetailType = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        :value="value"
        label="税种"
        placeholder="请选择"
        @click="showPaymentAccount = true"
      />
      <van-field
        input-align="right"
        :value="value"
        label="税费金额"
        placeholder="请选择"
      />
      <van-field
        input-align="right"
        :value="value"
        label="含税总费用"
        placeholder="请选择"
      />
      <van-field
        input-align="right"
        :value="value"
        label="备注单据号"
        placeholder="请输入"
      />
    </van-form>
    <div>
      <van-button class="add" type="primary" icon="plus" round @click="chosePhoto()"/>
      <van-button block type="primary" @click="EditcostRecord()">提交</van-button>
    </div>
    <!--收款单位弹窗-->
    <van-popup v-model="showCollectionCompany" position="bottom">
      <van-picker
        show-toolbar
        :columns="collectionCompany"
        @confirm="onCollectionCompanyConfirm"
        @cancel="showCollectionCompany = false"
      />
    </van-popup>
    <!--付款日期-->
    <van-popup v-model="showPaymentDate" position="bottom">
      <van-datetime-picker
        type="time"
        @confirm="onShowPaymentDateConfirm"
        @cancel="showPaymentDate = false"
      />
    </van-popup>
    <!--资金类别-->
    <van-popup v-model="showFundCategory" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.collectionCompany"
        @confirm="onCollectionCompanyConfirm"
        @cancel="showFundCategory = false"
      />
    </van-popup>
    <!--付款账户-->
    <van-popup v-model="showPaymentAccount" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.paymentAccount"
        @confirm="onCollectionCompanyConfirm"
        @cancel="showFundCategory = false"
      />
    </van-popup>
    <!--货币-->
    <van-popup v-model="showCurrency" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.currency"
        @confirm="onCollectionCompanyConfirm"
        @cancel="showCurrency = false"
      />
    </van-popup>
    <!--付款类别-->
    <van-popup v-model="showPaymentType" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.paymentType"
        @confirm="onCollectionCompanyConfirm"
        @cancel="showPaymentType = false"
      />
    </van-popup>
    <!--付款子类别-->
    <van-popup v-model="showPaymentSubType" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.paymentSubType"
        @confirm="onCollectionCompanyConfirm"
        @cancel="showPaymentSubType = false"
      />
    </van-popup>
    <!--详细类别-->
    <van-popup v-model="showDetailType" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.detailType"
        @confirm="onCollectionCompanyConfirm"
        @cancel="showDetailType = false"
      />
    </van-popup>
    <!--    <article>-->
    <!--      <a href="javascript:;" class="add" @click="chosePhoto()"> <img id="imCon" src="../../../static/img/add_03.png"-->
    <!--                                                                     alt=""></a>-->
    <!--      <div class="Centermain">-->
    <!--        <div class="inCon">-->
    <!--          <li class="inCon1">-->
    <!--            <p>费用金额</p>-->
    <!--            <input type="text" placeholder="请输入金额" v-model="Amount">-->
    <!--          </li>-->
    <!--          <li class="inCon3">-->
    <!--            <p>供应商</p>-->
    <!--            <p>-->
    <!--              <input id="icon2" type="text" placeholder="请输入供应商" v-model="Log" @click="toCus" readonly>-->
    <!--              <vue-pickers-->
    <!--                :show="isshow"-->
    <!--                :columns="columns"-->
    <!--                :selectData="customercon"-->
    <!--                @cancel="close1"-->
    <!--                @confirm="concus">-->
    <!--              </vue-pickers>-->
    <!--            </p>-->
    <!--            <a href="javascript:;">-->
    <!--              <img src="../../../static/img/xjiant.png" alt="">-->
    <!--            </a>-->
    <!--            &lt;!&ndash;<div id="custormlog">&ndash;&gt;-->
    <!--            &lt;!&ndash;<p v-for="(item,i) in customerList" @click="getstate(customerList[i])">{{customerList[i]}}</p> @click="both()"&ndash;&gt;-->
    <!--            &lt;!&ndash;</div>&ndash;&gt;-->
    <!--          </li>-->
    <!--          <li class="inCon2">-->
    <!--            <p>付款方式</p>-->
    <!--            <p>-->
    <!--              <input type="text" placeholder="请输入银行存款" value="银行存款" v-model="RPType" id="rptype" @click="toRPType"-->
    <!--                     readonly>-->
    <!--              <vue-pickers-->
    <!--                :show="isshow4"-->
    <!--                :columns="columns"-->
    <!--                :selectData="RPTypeconlist"-->
    <!--                @cancel="close4"-->
    <!--                @confirm="RPTypecon">-->
    <!--              </vue-pickers>-->
    <!--              <a href="javascript:;">-->
    <!--                <img src="../../../static/img/xjiant.png" alt="">-->
    <!--              </a>-->
    <!--            </p>-->
    <!--          </li>-->
    <!--          <li class="inCon3">-->
    <!--            <p>付款子类</p>-->
    <!--            <p>-->
    <!--              <input type="text" placeholder="请选择" v-model="subcategory" id="sub" @click="tosub" readonly>-->
    <!--              <vue-pickers-->
    <!--                :show="isshow5"-->
    <!--                :columns="columns"-->
    <!--                :selectData="subcacon"-->
    <!--                @cancel="close5"-->
    <!--                @confirm="subcatecon">-->
    <!--              </vue-pickers>-->
    <!--              <a href="javascript:;">-->
    <!--                <img src="../../../static/img/xjiant.png" alt="">-->
    <!--              </a>-->
    <!--            </p>-->
    <!--          </li>-->
    <!--          <li class="inCon3">-->
    <!--            <p>业务单元</p>-->
    <!--            <p>-->
    <!--              <input type="text" placeholder="请选择业务单元" v-model="Business_GUID" readonly>-->
    <!--              <a href="javascript:;">-->
    <!--                <img src="../../../static/img/xjiant.png" alt="">-->
    <!--              </a>-->
    <!--            </p>-->
    <!--          </li>-->
    <!--          <li class="inCon3">-->
    <!--            <p>业务子单元</p>-->
    <!--            <p>-->
    <!--              <input type="text" placeholder="请选择业务子单元" v-model="SubBusiness_GUID" readonly>-->
    <!--              <a href="javascript:;">-->
    <!--                <img src="../../../static/img/xjiant.png" alt="">-->
    <!--              </a>-->
    <!--            </p>-->
    <!--          </li>-->
    <!--          <li class="inCon2">-->
    <!--            <p>货币</p>-->
    <!--            <p>-->
    <!--              <input type="text" placeholder="货币" id="btncon2" @click="toCurry" v-model="Currency" readonly>-->
    <!--              <vue-pickers-->
    <!--                :show="isshow2"-->
    <!--                :columns="columns"-->
    <!--                :selectData="currencyCon"-->
    <!--                @cancel="close2"-->
    <!--                @confirm="currycon">-->
    <!--              </vue-pickers>-->
    <!--              <a href="javascript:;">-->
    <!--                <img src="../../../static/img/xjiant.png" alt="">-->
    <!--              </a>-->
    <!--            </p>-->
    <!--          </li>-->
    <!--          <li class="inCon2">-->
    <!--            <p>收入确认日期</p>-->
    <!--            <p>-->
    <!--              &lt;!&ndash;<datetime id="icon3"  placeholder="请输入日期"  v-model="AffirmDate" style="margin-right: -64px;text-align: right"></datetime>&ndash;&gt;-->
    <!--              <input class="js-startdate-picker" type="text" placeholder="请输入日期" v-model="AffirmDate" readonly>-->
    <!--              <a href="javascript:;">-->
    <!--                <img src="../../../static/img/xjiant.png" alt="">-->
    <!--              </a>-->
    <!--            </p>-->
    <!--          </li>-->
    <!--          <li class="inCon2">-->
    <!--            <p>收款截止日期</p>-->
    <!--            <p>-->
    <!--              &lt;!&ndash;<datetime id="icon4" placeholder="请输入日期" v-model="Datec" style="margin-right: -64px"></datetime>&ndash;&gt;-->
    <!--              <input class="js-enddate-picker" type="text" placeholder="请输入日期" v-model="Datec" readonly>-->
    <!--              <a href="javascript:;">-->
    <!--                <img src="../../../static/img/xjiant.png" alt="">-->
    <!--              </a>-->
    <!--            </p>-->
    <!--          </li>-->
    <!--          <li class="inCon3">-->
    <!--            <p>详细类别</p>-->
    <!--            <p>-->
    <!--              <input type="text" placeholder="请选择收入类型" v-model="InvType" readonly>-->
    <!--              <a href="javascript:;">-->
    <!--                <img src="../../../static/img/xjiant.png" alt="">-->
    <!--              </a>-->
    <!--            </p>-->
    <!--          </li>-->
    <!--          <li class="inCon3">-->
    <!--            <p>税种</p>-->
    <!--            <p>-->
    <!--              &lt;!&ndash;<input type="text" placeholder="请选择税种" v-model="TaxationType">&ndash;&gt;-->
    <!--              <input id="cafees" type="text" placeholder="请选择税种" @click="toShow" v-model="TaxationType" readonly>-->
    <!--              <vue-pickers-->
    <!--                :show="show"-->
    <!--                :columns="columns"-->
    <!--                :selectData="cafeesCon"-->
    <!--                @cancel="close"-->
    <!--                @confirm="catfeesCon">-->
    <!--              </vue-pickers>-->
    <!--              <a href="javascript:;">-->
    <!--                <img src="../../../static/img/xjiant.png" alt="">-->
    <!--              </a>-->
    <!--            </p>-->
    <!--          </li>-->
    <!--          <li class="inCon3">-->
    <!--            <p>税费金额</p>-->
    <!--            <p>-->
    <!--              <input type="text" placeholder="0.00" v-model="TaxationAmount" readonly>-->
    <!--            </p>-->
    <!--          </li>-->
    <!--          <li class="inCon3">-->
    <!--            <p>含税总费用</p>-->
    <!--            <p>-->
    <!--              <input type="text" placeholder="0.00" v-model="SumAmount" readonly>-->
    <!--            </p>-->
    <!--          </li>-->
    <!--          <li class="inCon3">-->
    <!--            <p>备注单据号</p>-->
    <!--            <p>-->
    <!--              <input type="text" placeholder="请输入" v-model="Remark">-->
    <!--            </p>-->
    <!--          </li>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </article>-->
    <!--    <footer>-->

    <!--      <div class="btn" @click="EditcostRecord">-->
    <!--        保存-->
    <!--      </div>-->
    <!--    </footer>-->
  </section>

</template>

<script>
  import vuePickers from 'vue-pickers'

  export default {
    name: "uploadcostedit",
    components: {
      vuePickers
    },
    data() {
      return {
        showCollectionCompany: false,//收款单位弹窗
        showPaymentDate: false,//付款日期
        showFundCategory: false,//付款账户
        showPaymentAccount: false,//资金类别
        showCurrency: false,//货币
        showPaymentType: false,//付款类别
        showPaymentSubType: false,//付款子类别
        showDetailType: false,//详细类别
        popupData: {
          collectionCompany: [//收款单位
            {text: '单位1', value: '1'},
            {text: '单位2', value: '2'}
          ],
          fundCategory: [//资金类别
            {text: '类别1', value: '1'},
            {text: '类别2', value: '2'}
          ],
          paymentAccount: [//付款账户
            {text: '账户1', value: '1'},
            {text: '账户2', value: '2'}
          ],
          currency: [//货币
            {text: '货币1', value: '1'},
            {text: '货币2', value: '2'}
          ],
          paymentType: [//付款类别
            {text: '付款类别1', value: '1'},
            {text: '付款类别2', value: '2'}
          ],
          paymentSubType: [//付款子类别
            {text: '付款子类别1', value: '1'},
            {text: '付款子类别2', value: '2'}
          ],
          detailType: [//详细类别
            {text: '详细类别1', value: '1'},
            {text: '详细类别2', value: '2'}
          ],
        },
        //==============================//
        subcategory: '',
        isshow5: false,
        subcatelist: [],
        subcacon: {
          data1: [{
            text: '1111',
            value: '1111'
          }]
        },
        isshow: false,
        isshow2: false,
        isshow4: false,
        show: false,
        columns: 1,
        customerList: ['全部', '其他'],
        currencyList: '',
        DetailInvtype: '',
        DetailInvtype1: '',
        DetailRPType: '',
        file: '',
        timeCon: '',
        nonce: '',
        sigin: '',
        IEGroup: '',
        ManCon: [],
        Business_GUID: '',
        Currency: '',
        Datec: '',
        AffirmDate: '',
        Amount: '',
        DC_GUID: '',
        InvNo: '',
        TaxationAmount: '',
        SumAmount: '',
        DisAmount: '',
        IE_GUID: '',
        InvType: '',
        Log: '',
        Log_c: '',
        RPType: '',
        RPer: '',
        Remark: '',
        State: '',
        SubBusiness_GUID: '',
        TaxationType: '',
        C_GUID: '',
        Creator: '',
        catfeesList: [],
        cafeesCon: {
          data1: [{
            text: '',
            value: ''
          }]
        },
        currencyCon: {
          data1: [{
            text: '',
            value: ''
          }]
        },
        customercon: {
          data1: [{
            text: '1111',
            value: '1111'
          }]
        },
        RPTypeconlist: {
          data1: [
            {
              text: '111111',
              value: '111111'
            },
          ]
        }
      }
    },
    mounted() {
      this.BirthDateSelect()
      this.BirthEndDateSelect()
      this.catfees()
      this.getcurrency()
      this.GetCustomer()
      this.GetBankInfo();
      this.GetPayOrReceivablesType()
      this.getcon()
    },
    methods: {
      //  确认收提交的数据
      EditcostRecord() {
        let a = JSON.parse(sessionStorage.getItem('costcon'))
        let indexi = sessionStorage.getItem('indexcost')
        a[indexi].Amount = this.Amount === '' ? 0 : this.Amount
        a[indexi].Log = this.Log
        a[indexi].Currency = this.Currency
        a[indexi].Date = this.Datec
        a[indexi].AffirmDate = this.AffirmDate
        a[indexi].TaxationType = this.TaxationType
        a[indexi].SumAmount = this.SumAmount === '' ? 0 : this.SumAmount
        a[indexi].Remark = this.Remark
        a[indexi].InvNo = this.InvNo
        a[indexi].RPType = this.RPType
        sessionStorage.setItem('costcon', JSON.stringify(a))
        this.$router.push({path: '/uploadcost'})
      },
      //获取sessionStorage页面的数据
      getcon() {
        let a = JSON.parse(sessionStorage.getItem('costcon'))
        let indexi = sessionStorage.getItem('indexcost')
        this.Amount = a[indexi].Amount
        this.Log = a[indexi].Log
        this.AffirmDate = a[indexi].AffirmDate
        this.Remark = a[indexi].Remark
        this.InvNo = a[indexi].InvNo
        this.Datec = a[indexi].Date
      },
      //  开始时间
      BirthDateSelect() {
        var calendar = new datePicker();
        calendar.init({
          trigger: ".js-startdate-picker", /*按钮选择器，用于触发弹出插件*/
          type:
            "date" /*模式：date日期；datetime日期时间；time时间；ym年月；year:年*/,
          minDate: "1900-1-1" /*最小日期*/,
          maxDate: "2100-12-31" /*最大日期*/,
          onSubmit: function () {
            /*确认时触发事件*/
            var theSelectData = calendar.value;
          },
          onClose: function () {
            /*取消时触发事件*/
          }
        });
      },
      //结束时间
      BirthEndDateSelect() {
        var calendar = new datePicker();
        calendar.init({
          trigger: ".js-enddate-picker", /*按钮选择器，用于触发弹出插件*/
          type:
            "date" /*模式：date日期；datetime日期时间；time时间；ym年月；year:年*/,
          minDate: "1900-1-1" /*最小日期*/,
          maxDate: "2100-12-31" /*最大日期*/,
          onSubmit: function () {
            /*确认时触发事件*/
            var theSelectData = calendar.value;
          },
          onClose: function () {
            /*取消时触发事件*/
          }
        });
      },
      //获取付款子类
      GetBankInfo() {
        this.$axios({
          method: 'post',
          url: '/fmsapi/common/GetBankInfo',
          data: this.$qs.stringify({
            cGuid: sessionStorage.getItem('companyId')
          })
        }).then(res => {
          this.subcatelist = res.data
          this.subcacon.data1 = new Array()
          console.log(this.subcatelist)
          for (var i = 0; i < this.subcatelist.length; i++) {
            this.subcacon.data1.push({'text': this.subcatelist[i].label, 'value': this.subcatelist[i].label})
          }

        })
      },
      //获取付款方式
      GetPayOrReceivablesType() {
        this.$axios({
          method: 'post',
          url: '/fmsapi/common/GetPayOrReceivablesType',
          data: this.$qs.stringify({
            cGuid: sessionStorage.getItem('companyId')
          })
        }).then(res => {
          this.RPTypeconcon = res.data
          this.RPTypeconlist.data1 = new Array();
          for (var i = 0; i < this.RPTypeconcon.length; i++) {
            this.RPTypeconlist.data1.push({
              "text": this.RPTypeconcon[i].label,
              'value': this.RPTypeconcon[i].label,
              'payid': this.RPTypeconcon[i].value
            })
          }
        })
      },
      //获取货币
      getcurrency() {
        this.$axios.post('/fmsapi/common/GetSearchCurrency').then(res => {
          this.currencyList = res.data.result
          this.currencyCon.data1 = new Array();
          for (var i = 0; i < this.currencyList.length; i++) {
            this.currencyCon.data1.push({"text": this.currencyList[i].Code, "value": this.currencyList[i].Code})
          }
        })
      },
      currycon(val) {
        var btn3 = document.getElementById('btncon2')
        this.isshow2 = false
        btn3.value = val.select1.value
        this.Currency = btn3.value
        // console.log(JSON.parse(this.defaultData))
      },
      close2() {
        console.log(123)
        this.isshow2 = false
      },
      toCurry(val) {
        this.isshow2 = true
        // var btn=document.getElementById('btn')
        // console.log(val)
        // this.res = btn.value
      },
      //获取所有的供应商
      GetCustomer() {
        var custormlog = document.getElementById('custormlog')
        this.$axios({
          method: 'post',
          url: '/fmsapi/common/GetPayeeJson',
          data: this.$qs.stringify({
            C_GUID: sessionStorage.getItem('companyId')
          })
        }).then(res => {
          this.customerList = res.data.result
          // custormlog.style.display="block"
          this.customercon.data1 = new Array();
          for (var i = 0; i < this.customerList.length; i++) {
            this.customercon.data1.push({
              "text": this.customerList[i].Name,
              "value": this.customerList[i].Name,
              'RPercon': this.customerList[i].BP_GUID
            })
          }
        })
      },
      concus(val) {
        var btn2 = document.getElementById('icon2')
        console.log(val.select1.value)
        sessionStorage.setItem('RPercon', val.select1.RPercon)
        this.isshow = false
        btn2.value = val.select1.value
        this.Log = btn2.value
        // console.log(JSON.parse(this.defaultData))
      },
      close1() {
        console.log(123)
        this.isshow = false
      },
      toCus(val) {
        this.isshow = true
        // var btn=document.getElementById('btn')
        // console.log(val)
        // this.res = btn.value
      },
      //获取税种
      catfees() {
        var catfees = document.getElementById('catfees')
        this.$axios({
          method: 'post',
          url: '/fmsapi/common/GetTaxListType',
          data: this.$qs.stringify({
            C_GUID: sessionStorage.getItem('companyId'),
          })
        }).then(res => {
          this.catfeesList = res.data.result
          this.cafeesCon.data1 = new Array();
          for (var i = 0; i < this.catfeesList.length; i++) {
            this.cafeesCon.data1.push({
              "text": this.catfeesList[i].Name,
              "value": this.catfeesList[i].Name,
              'T_GUID': this.catfeesList[i].T_GUID,
              'Rate': this.catfeesList[i].Rate
            })
          }
        })
      },
      catfeesCon(val) {
        var btn = document.getElementById('cafees')
        this.show = false
        btn.value = val.select1.value
        sessionStorage.setItem('T_GUID', val.select1.T_GUID)
        sessionStorage.setItem('catname', val.select1.value)
        sessionStorage.setItem('Rate', val.select1.Rate)
        this.TaxationType = btn.value
        console.log(this.TaxationType)
        if (sessionStorage.getItem('Rate') && this.Amount !== '') {
          var a = sessionStorage.getItem('Rate')
          this.TaxationAmount = parseFloat((this.Amount) / (1 + a / 100) * (a / 100)).toFixed(2)
          this.SumAmount = parseFloat(this.Amount)
          this.Amount = parseFloat(this.SumAmount - this.TaxationAmount).toFixed(2)
        } else {
          this.TaxationType = ''
          alert('请输入收入金额')
        }
      },
      toShow(val) {
        this.show = true
        // var btn=document.getElementById('btn')
        // console.log(val)
        // this.res = btn.value
      },
      close() {
        console.log(123)
        this.show = false
      },
      //获取银行存款
      RPTypecon(val) {
        var btn4 = document.getElementById('rptype')
        console.log(val.select1.value)
        sessionStorage.setItem('payid', val.select1.payid)
        this.isshow4 = false
        btn4.value = val.select1.value
        this.RPType = btn4.value
      },
      close4() {
        console.log(123)
        this.isshow4 = false
      },
      toRPType(val) {
        this.isshow4 = true
      },
      //获取付款子类
      subcatecon(val) {
        var sub = document.getElementById('sub')
        this.isshow5 = false
        sub.value = val.select1.value
        this.subcategory = sub.value
      },
      close5() {
        this.isshow5 = false
      },
      tosub(val) {
        if (this.RPType === '银行存款') {
          this.isshow5 = true
        } else {
          this.isshow5 = false
        }
      },
      back() {
        this.$router.push('/home')
      }
    }
  }
</script>

<style lang="less" scoped>
  .wrapper {
    background: white;

    .add {
      position: absolute;
      bottom: 10rem;
      right: 0;
    }
  }
</style>
